var _rect, _path, _path2, _path3, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditWithBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 4.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 26.2491C15 25.8344 15.3358 25.4982 15.75 25.4982H26.25C26.6642 25.4982 27 25.8344 27 26.2491C27 26.6638 26.6642 27 26.25 27H15.75C15.3358 27 15 26.6638 15 26.2491Z",
    fill: "#777777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0713 10.6101C23.9234 10.4639 23.685 10.466 23.5397 10.6148L11.3624 23.0652L10.7714 25.3135L13.1341 24.9114L25.3649 12.4336C25.5092 12.2858 25.5071 12.0491 25.3602 11.9039L24.0713 10.6101ZM22.4671 9.56501C23.1934 8.82107 24.3855 8.81039 25.125 9.5412L26.4139 10.8351C27.1484 11.5609 27.159 12.7446 26.4375 13.4835L14.0363 26.1357C13.9256 26.2491 13.7819 26.3245 13.6257 26.3511L9.87571 26.9894C9.62444 27.0321 9.36867 26.9442 9.19663 26.7559C9.0246 26.5676 8.95984 26.3048 9.02471 26.058L9.96221 22.4911C9.99527 22.3653 10.0604 22.2503 10.1512 22.1573L22.4671 9.56501Z",
    fill: "#777777"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3107 10.9197L25.0607 14.6743L24 15.7363L20.25 11.9817L21.3107 10.9197Z",
    fill: "#777777"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 4.5,
    stroke: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWithBorder);
export default __webpack_public_path__ + "static/media/EditWithBorder.3859d480858114cbd4aa861ab40ae4e5.svg";
export { ForwardRef as ReactComponent };